import styled, { css } from 'styled-components';
import { colors } from 'global/colors';

export const ButtonsContainerStyle = styled.div`
  ${({ padding = '0.5rem' }) => css`
    padding: ${padding};
  `}
  ${({ alignCenter }) =>
    alignCenter &&
    css`
      text-align: center;
    `}
`;

export const RectangleButtonStyle = styled.button.attrs({ className: 'btn' })`
  color: ${colors.white};
  background-color: ${colors.darkBlue};
  border-color: ${colors.darkBlue};
  margin: 0;
  padding: 0.375rem 1rem;
  &:hover {
    color: ${colors.white};
    background: ${colors.hoverBlue};
    border-color: ${colors.hoverBlue};
  }
  &:focus {
    outline: 0 none !important;
    box-shadow: none;
  }

  ${({ small }) =>
    small &&
    css`
      font-size: 0.875rem;
      padding: 0.25rem 0.75rem;
    `}
  ${({ marginLeft }) =>
    marginLeft &&
    css`
      margin-left: 0.5rem;
    `}
  ${({ marginRight }) =>
    marginRight &&
    css`
      margin-right: 0.5rem;
    `}
  ${({ floatRight }) =>
    floatRight &&
    css`
      float: right;
    `}
`;

export const RectangleButtonLinkStyle = styled.a.attrs({ className: 'btn' })`
  appearance: button;
  color: ${colors.white};
  background-color: ${colors.darkBlue};
  border-color: ${colors.darkBlue};
  margin: 0;
  padding: 0.375rem 1rem;
  &:hover {
    color: ${colors.white};
    background: ${colors.hoverBlue};
    border-color: ${colors.hoverBlue};
  }
  &:focus {
    outline: 0 none !important;
    box-shadow: none;
  }

  ${({ small }) =>
    small &&
    css`
      font-size: 0.875rem;
      padding: 0.25rem 0.75rem;
    `}
  ${({ marginLeft }) =>
    marginLeft &&
    css`
      margin-left: 0.5rem;
    `}
${({ marginRight }) =>
    marginRight &&
    css`
      margin-right: 0.5rem;
    `}
${({ floatRight }) =>
    floatRight &&
    css`
      float: right;
    `}
`;

export const TwitterButtonStyle = styled.div`
  color: ${colors.white};
  background: ${colors.darkBlue};
  padding: 6px 18px;
  border-radius: 25px;
  border: 2px solid transparent;
  transition: padding 0.25s ease-in-out;
  cursor: pointer;

  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  user-select: none;

  :hover {
    color: ${colors.green};
    background: ${colors.white};
    text-decoration: none;
    border: 2px solid ${colors.green};
  }
`;
